.footer {
  border-top: 1px solid var(--color-border);
  padding: 32px 24px 40px;
  background: rgba(0, 0, 0, 0.25);
}

.inner {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  max-width: var(--max-width);
  margin: 0 auto;
}

.copy {
  font-size: 14px;
  color: var(--color-text-dim);
}

.links {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.link {
  font-size: 14px;
  color: var(--color-text-muted);
  transition: color 0.15s ease;
}

.link:hover {
  color: var(--color-gold);
}

.linkButton {
  padding: 0;
  border: none;
  background: none;
  font: inherit;
  font-size: 14px;
  color: var(--color-text-muted);
  cursor: pointer;
  transition: color 0.15s ease;
}

.linkButton:hover {
  color: var(--color-gold);
}
